module.exports = __webpack_public_path__ + "img/slider2a-d6a07479.5bbd0baf.webp";